import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1520870121499-7dddb6ccbcde?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); toast.success("Login berhasil"); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.2fr_1fr]">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={HERO} alt="Survei udara" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#0B0F17]/70" />
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="relative flex h-full flex-col justify-end p-14">
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-sky-400">Kota Semarang · Jawa Tengah</p>
          <h1 className="font-display text-6xl font-extrabold leading-[0.95] mt-4">Pemetaan 3D<br />Semarang</h1>
          <p className="mt-5 max-w-md text-slate-300">Pelaporan progres akuisisi udara, pengolahan foto & LiDAR, digitasi 2D hingga pemodelan 3D dalam satu panel.</p>
          <div className="mt-10 flex gap-10 font-mono text-xs text-slate-400">
            <span>LAT −6.99°</span><span>LON 110.42°</span><span>EPSG:4326</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 grid-bg">
        <form onSubmit={submit} className="rise w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-sky-400">Akses Sistem</p>
            <h2 className="font-display text-4xl font-extrabold mt-2">Masuk</h2>
            <p className="text-sm text-slate-400 mt-1">Gunakan akun admin atau viewer yang telah terdaftar.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="bg-[#131B29] h-11" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="bg-[#131B29] h-11" />
          </div>
          {error && <p className="rounded-md border border-rose-500/40 bg-rose-500/10 px-3 py-2 text-sm text-rose-300" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="h-11 w-full rounded-full font-semibold" data-testid="login-submit-button">{busy ? "Memproses..." : "Masuk"}</Button>
        </form>
      </div>
    </div>
  );
}
